// extracted by mini-css-extract-plugin
export default {"button":"vk-z","reviewSort":"wk-z"};